import { Component, OnInit } from "@angular/core";
import { NgbDropdownConfig } from "@ng-bootstrap/ng-bootstrap";

import { SettingsService } from "./settings/settings.service";
import { AuthService } from "./auth.service";
import { Settings } from "./settings/settings.model";
import { User } from "./models/user.model";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  onDestroy$ = new Subject();
  isMobileNavbar = false;
  settings: Settings = new Settings();
  user: User = new User();

  public constructor(
    private settingsService: SettingsService,
    private authService: AuthService,
    private router: Router,
    private config: NgbDropdownConfig
  ) {
    // customize default values of dropdowns used by this component tree
    config.placement = "bottom-right";
    config.autoClose = true;
  }

  /**
   * Initialise view
   */
  ngOnInit() {
    this.getSettings();
    this.checkLogin();
  }

  /**
   * Get the app global settings for the app, eg portal name
   */
  private getSettings(): void {
    this.settingsService
      .getSettings()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          this.settings = data;
        },
        (error) => {}
      );
  }

  /**
   * Checks if the user is logged in and subscribe to username changes
   */
  private checkLogin(): void {
    this.user = this.authService.checkLoginStatus();
    this.authService.usernameChanged$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((value) => {
        this.user = JSON.parse(localStorage.getItem("mapCloudPortalUser"));
      });
  }

  /**
   * Log the user out
   */
  logout() {
    this.authService.logout();
    this.user = JSON.parse(localStorage.getItem("mapCloudPortalUser"));
    this.router.navigate(["/"]);
  }

  /**
   * @returns void
   */
  ngOnDestroy(): void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }
}
